import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth.jsx";
import AlertsBell from "./AlertsBell.jsx";
import {
  LayoutDashboard,
  List,
  Star,
  Users,
  Activity,
  LogOut,
  KeyRound,
  Sparkles,
} from "lucide-react";

const baseLink =
  "flex items-center gap-3 px-4 py-2.5 rounded-md text-sm transition-colors duration-150 group";
const activeLink = "bg-sidebar-accent text-sidebar-accent-foreground font-medium";
const inactiveLink = "text-sidebar-foreground/70 hover:bg-sidebar-accent/60 hover:text-sidebar-foreground";

export default function Sidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isAdmin = user?.role === "admin";

  return (
    <aside
      className="w-64 shrink-0 bg-sidebar border-r border-sidebar-border min-h-screen flex flex-col"
      data-testid="app-sidebar"
    >
      <div className="px-6 py-6 border-b border-sidebar-border">
        <div className="flex items-center gap-2">
          <div className="w-9 h-9 rounded-md bg-sidebar-primary text-sidebar-primary-foreground flex items-center justify-center font-display font-bold text-base">
            S
          </div>
          <div className="min-w-0 flex-1">
            <div className="font-display text-base font-bold tracking-tight">SoIIN</div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
              Stock Intelligence
            </div>
          </div>
          <AlertsBell />
        </div>
      </div>

      <nav className="flex-1 px-3 py-4 space-y-1">
        <NavLink
          to="/"
          end
          className={({ isActive }) => `${baseLink} ${isActive ? activeLink : inactiveLink}`}
          data-testid="nav-top12"
        >
          <Sparkles className="w-4 h-4" />
          <span>Top 12 Compras</span>
        </NavLink>
        <NavLink
          to="/listagem"
          className={({ isActive }) => `${baseLink} ${isActive ? activeLink : inactiveLink}`}
          data-testid="nav-listing"
        >
          <List className="w-4 h-4" />
          <span>Listagem</span>
        </NavLink>
        <NavLink
          to="/favoritos"
          className={({ isActive }) => `${baseLink} ${isActive ? activeLink : inactiveLink}`}
          data-testid="nav-favorites"
        >
          <Star className="w-4 h-4" />
          <span>Favoritos</span>
        </NavLink>

        {isAdmin && (
          <div className="pt-4 mt-4 border-t border-sidebar-border">
            <div className="px-4 pb-2 text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
              Administração
            </div>
            <NavLink
              to="/admin/usuarios"
              className={({ isActive }) => `${baseLink} ${isActive ? activeLink : inactiveLink}`}
              data-testid="nav-admin-users"
            >
              <Users className="w-4 h-4" />
              <span>Usuários</span>
            </NavLink>
            <NavLink
              to="/admin/sistema"
              className={({ isActive }) => `${baseLink} ${isActive ? activeLink : inactiveLink}`}
              data-testid="nav-admin-system"
            >
              <Activity className="w-4 h-4" />
              <span>Sistema</span>
            </NavLink>
          </div>
        )}
      </nav>

      <div className="px-3 py-4 border-t border-sidebar-border space-y-1">
        <div className="px-4 py-2">
          <div className="text-xs text-muted-foreground">Logado como</div>
          <div className="text-sm font-medium truncate" data-testid="sidebar-user-name">
            {user?.full_name}
          </div>
          <div className="text-[11px] text-muted-foreground truncate">{user?.email}</div>
        </div>
        <button
          onClick={() => navigate("/conta/senha")}
          className={`${baseLink} ${inactiveLink} w-full text-left`}
          data-testid="nav-change-password"
        >
          <KeyRound className="w-4 h-4" />
          <span>Alterar senha</span>
        </button>
        <button
          onClick={logout}
          className={`${baseLink} ${inactiveLink} w-full text-left`}
          data-testid="logout-button"
        >
          <LogOut className="w-4 h-4" />
          <span>Sair</span>
        </button>
      </div>
    </aside>
  );
}
